import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class VideoV2 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return <div className="ltn__about-us-area section-bg-1 bg-image-right-before pt-120 pb-90">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-info-wrap">
			          <div className="section-title-area ltn__section-title-2--- mb-20">
			            <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">Building Facilities</h6>
			            <h1 className="section-title">Welcome to METRRO CITY, Manimangalam by Success Property!</h1>
			            <p>High Investment Potential: Situated in a fast-growing area with excellent return on investment prospects.</p>
			          </div>
			          <ul className="ltn__list-item-half ltn__list-item-half-2 list-item-margin clearfix">
			            <li>
			              <i className="icon-done" />
			              Prime Location: Strategically located with excellent connectivity to Chennai's major hubs
			            </li>
			            <li>
			              <i className="icon-done" />
			              Well-Developed Infrastructure: Wide roads, proper drainage, and streetlights for a modern living experience.
			            </li>
			            <li>
			              <i className="icon-done" />
			              Green Spaces: Parks and open areas for a peaceful and healthy environment.
			            </li>
			            <li>
			              <i className="icon-done" />
			              Convenient Amenities: Close to schools, colleges, hospitals, and supermarkets.
			            </li>
			            <li>
			              <i className="icon-done" />
			              High Investment Potential: Situated in a fast-growing area with excellent return on investment prospects.
			            </li>
						<li>
							<i className="icon-done"/>
							Own a plot at METRRO CITY and take the first step toward your dream home or a smart investment opportunity!
						</li>
			          </ul>
			          {/* <div className="  ltn__animation-pulse2 text-center mt-30">
			            <a className="ltn__video-play-btn bg-white--- ltn__secondary-bg" href="#" data-rel="lightcase">
			              <i className="icon-play  ltn__secondary-color--- white-color" />
			            </a>
			          </div> */}
			        </div>
			      </div>
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-img-wrap about-img-left">
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default VideoV2